import { formsApi } from './api';

export const sendInvitationEmail = (email, link, sender) => {
  const body = {
    toAddress: email,
    subject: 'Join FairView',
    textBody: `I've just joined this thing called FairView - I think it's something you might be interested in.\n

    FairView rewards their members for allowing advertisers to show them ads. Just sign up, install an extension in your browser and enter whatever personal data you like (it's saved securely and you can delete it whenever you like). Then FairView gets advertisers to pay you for you personal data and the space at the edge of your screen.\n

    FairView gives you a passive income - earn money for something you'd be doing anyway and be part of a much needed change in giving power back to internet users!\n

    Just use ${link} link to join up, it's free forever.

    Thanks

    ${sender}`,
    htmlBody: `<div>
      <div style="width:100%;">
        <img src="https://fairview-rewards.com/img/logo.png" style="width:400px;margin:auto;display:block;" />
      </div>
      <div>
        <p class="header">I've just joined this thing called FairView - I think it's something you might be interested in.</p>
        <p>FairView rewards their members for allowing advertisers to show them ads. Just sign up, install an extension in your browser and enter whatever personal data you like (it's saved securely and you can delete it whenever you like). Then FairView gets advertisers to pay you for you personal data and the space at the edge of your screen.</p>
        <p>FairView gives you a passive income - earn money for something you'd be doing anyway and be part of a much needed change in giving power back to internet users!</p>
        <div>
          <a href="${link}">Just click this link to join up, it's free forever.</a>
        </div>
        <p>Thanks</p>
        <p>${sender}</p>
      </div>
    </div>`,
  };

  return formsApi.post('send-auth', body);
};
